import type { EncodedFile } from '../types/types.js';

/**
 *
 */
export async function encodeFile(file : File | null | undefined) : Promise<EncodedFile|null> {
    if (file) try {
        const fileArrayBuffer = await file.arrayBuffer();
        const fileArrayBufferView = new Uint8Array(fileArrayBuffer);
        return {
            filename : file.name,
            mimeType: file.type,
            encodedContent : fileArrayBufferView.toBase64(),
        };
    } catch(error) { console.warn(`Error file ${file.name}: `, error); }
    return null;
}
